import { type FC } from 'react';

import { Outlet as RouterOutlet, useNavigate } from 'react-router';

import { useFeatureFlag } from '@/shared/hooks/use-feature-flag';

import { ROUTE_PATHS } from './types';

export const GuardDevPages: FC = () => {
  const navigate = useNavigate();

  const { hide } = useFeatureFlag();

  if (!hide('test')) {
    navigate(ROUTE_PATHS.MAIN);
    return null;
  }

  return <RouterOutlet />;
};
